import kebabCase from 'lodash/kebabCase';

const getCtaSectionId = (baseId: string, name: string): string =>
  `${baseId}-${kebabCase(name)}-cta-section`;

export default getCtaSectionId;
